var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotice = function SvgNotice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "notice_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#notice_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6 13.6c-.33 0-.613-.117-.848-.353A1.155 1.155 0 0 1 2.4 12.4V3.6c0-.33.117-.613.352-.848S3.27 2.4 3.6 2.4h2.85c.089-.344.275-.63.558-.858.284-.228.614-.342.992-.342s.708.114.992.342c.283.227.469.514.558.858h2.85c.33 0 .612.117.847.352s.353.518.353.848v8.8c0 .33-.118.612-.353.847a1.155 1.155 0 0 1-.847.353H3.6Zm0-1.2h8.8V3.6H3.6v8.8Zm1.2-1.2h4.8V10H4.8v1.2Zm0-2.6h6.4V7.4H4.8v1.2Zm0-2.6h6.4V4.8H4.8V6ZM8 3.2a.389.389 0 0 0 .4-.4.389.389 0 0 0-.4-.4.389.389 0 0 0-.4.4.389.389 0 0 0 .4.4Z",
    fill: "#404040"
  }))));
};
export default SvgNotice;